import { Sources } from '@app/constants/sourceConstants';

export const getMenTeamLogoUrl = (id: string): string => `${Sources.optaLogoMen}${id}.png`;

export const getWomenTeamLogoUrl = (id: string): string => `${Sources.optaLogoWomen}${id}.png`;
